module.exports = __webpack_public_path__ + "media/images/emblems/Wohlen_bei_Bern-coat_of_arms-0ac56a95f414795562d848b061e53af8.svg";